/**
 * App — thin bootstrap. Wires providers and router. Never add page logic here.
 */
import { Suspense } from "react";
import { Toaster } from "sonner";
import { AppRouter } from "./router";
import { RootErrorBoundary } from "@/shared/components/RootErrorBoundary";
import { PageSpinner } from "@/shared/components";
import { usePageDirection } from "@/shared/hooks/usePageDirection";
import { useTheme } from "@/shared/hooks/useTheme";

function App() {
  const dir = usePageDirection();
  const { isDark } = useTheme();
  return (
    <RootErrorBoundary>
      <Toaster
        theme={isDark ? "dark" : "light"}
        position={dir === "rtl" ? "top-left" : "top-right"}
        dir={dir}
        visibleToasts={3}
        closeButton={true}
        expand={false}
        richColors={false}
        toastOptions={{
          style: {
            fontFamily: "var(--font-sans)",
            borderRadius: "14px",
          },
        }}
      />
      {/* Safety net for the very first paint. Per-route navigation suspends at
          the shell-level boundaries (AppShell/AdminShell wrap their Outlet), so
          the sidebar stays put and only the content area shows the spinner. */}
      <Suspense fallback={<PageSpinner fullScreen />}>
        <AppRouter />
      </Suspense>
    </RootErrorBoundary>
  );
}

export default App;